export default {
  forms: state => state.forms,
  errors: state => state.errors
};
